import cx from 'classnames';
import * as React from 'react';
import { isNil } from 'lodash';

import Glyph from 'components/Glyph';
import { GlyphName } from '@remind/r101-glyphs';
import ProgressLabel from 'components/ProgressLabel';
import Text from 'components/Text';

import './styles/Progress.scss';

export type ProgressColor = 'apple' | 'pool' | 'globe' | 'mascot' | 'ballpoint' | 'pennant';
export type ProgressSize = 'medium' | 'small';

type DefaultProps = {
  color: ProgressColor;
  size: ProgressSize;
};

export type Props = {
  currentStep?: number;
  glyph?: GlyphName;
  label?: string;
  percent?: number;
  steps?: number;
} & DefaultProps;

// TODO
// * deprecate `size`?

export default class Progress extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    color: 'mascot',
    size: 'medium',
  };

  getDisplayPercent(): number {
    const { currentStep, percent, steps } = this.props;

    if (percent !== undefined) {
      return percent;
    }

    if (isNil(currentStep)) throw 'currentStep must be defined';
    if (isNil(steps)) throw 'currentStep must be defined';

    return (currentStep / steps) * 100;
  }

  renderLabel() {
    const { currentStep, label, steps } = this.props;
    let text = label;

    if (!label && !currentStep) {
      return null;
    }

    if (currentStep && steps) {
      text = `Step ${currentStep} of ${steps}`;
    }

    return (
      <Text
        element="div"
        size="xxxxsmall"
        smallCaps={!!currentStep}
        weight="semibold"
        className="Progress-label">
        {text}
      </Text>
    );
  }

  render() {
    const { color, currentStep, glyph, label, size, steps } = this.props;

    return (
      <div className={cx('Progress', size && `Progress--${size}`)}>
        {/* FlowIssue */}
        {glyph && (
          <Glyph name={glyph} color="graphite" size="xxxlarge" className="Progress-glyph" />
        )}
        <div className="Progress-bar">
          <div
            style={{ width: `${this.getDisplayPercent()}%` }}
            className={cx('Progress-bar-value', color && `Progress-bar-value--${color}`)}
          />
        </div>
        <ProgressLabel currentStep={currentStep} label={label} steps={steps} />
      </div>
    );
  }
}
